module.exports = __webpack_public_path__ + "static/media/interswitch.367ff42b.svg";